<template>
  <section
    class="mc-hero mc-hero--compact"
    aria-labelledby="mc-hero-titulo"
  >
    <div class="mc-hero__row">
      <div
        class="mc-hero__icon-wrap"
        aria-hidden="true"
      >
        <feather-icon
          icon="CpuIcon"
          size="22"
          class="mc-hero__icon"
        />
      </div>
      <div class="mc-hero__copy">
        <h1
          id="mc-hero-titulo"
          class="mc-hero__titulo"
        >
          {{ titulo }}
        </h1>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroImpactoBot',
  props: {
    titulo: {
      type: String,
      default: 'Visão Geral do Assistente',
    },
  },
}
</script>

<style scoped>
.mc-hero {
  position: relative;
  border-radius: var(--mc-radius-xl, 30px);
  background: linear-gradient(135deg, #6f35d0 0%, #b43fcf 48%, #ff7b6e 100%);
  box-shadow: var(--mc-shadow-lg, 0 20px 50px rgba(116, 57, 176, 0.18));
  margin-bottom: 1.25rem;
  font-family: 'Plus Jakarta Sans', 'Inter', system-ui, sans-serif;
  overflow: hidden;
  animation: mcHeroIn 0.55s ease-out both;
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}

.mc-hero:hover {
  box-shadow: 0 22px 52px rgba(116, 57, 176, 0.22);
  transform: translateY(-1px);
}

.mc-hero--compact {
  padding: 18px 20px;
}

@media (min-width: 768px) {
  .mc-hero--compact {
    padding: 20px 28px;
  }
}

@keyframes mcHeroIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mc-hero__row {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  min-width: 0;
}

.mc-hero__icon-wrap {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
}

.mc-hero__icon {
  color: #fff !important;
}

.mc-hero__copy {
  min-width: 0;
  flex: 1 1 auto;
}

.mc-hero__titulo {
  font-size: clamp(1.35rem, 3.8vw, 1.85rem);
  font-weight: 800;
  line-height: 1.2;
  color: #fff;
  margin: 0;
  letter-spacing: -0.03em;
}

@media (max-width: 767.98px) {
  .mc-hero__row {
    align-items: flex-start;
  }
}
</style>
